import {Box} from "@mui/system";
import GorgiasSection from './GorgiasSection';
import SalesforceSection from "./SalesforceSection";
import SupervisedChatSection from "./SupervisedChatSection";
import KustomerSection from "./KustomerSection";
import {accessibilityMode} from "../organizationSettingsConstants";

export default function DataSourceDetails({handle, label, mode}) {
    const isSalesforce = () => {
        return handle.msgSourceName?.toLowerCase()?.includes('salesforce');
    };

    return (
        <Box>
            { handle.supervisedChat.available && mode === accessibilityMode.EDIT && (<SupervisedChatSection handle={handle} label={label} />) }
            { handle.gorgias && (<GorgiasSection handle={handle} label={label} />) }
            { handle.kustomer && (<KustomerSection handle={handle} label={label} />) }
            { isSalesforce() && (<SalesforceSection handle={handle} label={label} />) }
        </Box>
    );
}
